import { MainTabBasePathEnum } from '../enums/main-tabs';
import { ProfileSearchEnum } from '../enums/profile-search';

export function getMainRouteByPropertySearchType(searchType: ProfileSearchEnum) {
  let result: MainTabBasePathEnum | string;

  switch (searchType) {
    case ProfileSearchEnum.PropertySearch:
      result = MainTabBasePathEnum.PropertySearch;
      break;
    case ProfileSearchEnum.PropertySearchWalkingFarm:
      result = `${MainTabBasePathEnum.PropertySearch}/walking-farm`;
      break;
    case ProfileSearchEnum.WalkingFarm:
      result = MainTabBasePathEnum.WalkingFarm;
      break;
  }

  return result ?? '/';
}
